import React from "react";
import { ParagraphParagraphTextBlock } from "../components/paragraphs/ParagraphParagraphTextBlock";
import { ParagraphHeaderImage } from "../components/paragraphs/ParagraphHeaderImage";
import { ParagraphLinks } from "../components/paragraphs/ParagraphLinks";
import { ParagraphQuoteBlock } from "../components/paragraphs/ParagraphQuoteBlock";
import { ParagraphSimpleQuote } from "../components/paragraphs/ParagraphSimpleQuote";
import { ParagraphDepartmentBlockPeople } from "../components/paragraphs/ParagraphDepartmentBlockPeople";
import { ParagraphPartnerLogos } from "../components/paragraphs/ParagraphPartnerLogos";
import { ParagraphKeyPublications } from "../components/paragraphs/ParagraphKeyPublications";
import { ParagraphNodeExpertOpinion } from "../components/paragraphs/ParagraphNodeExpertOpinion";
import { ParagraphNodeMediaCentre } from "../components/paragraphs/ParagraphNodeMediaCentre";
import { ParagraphNodeCountryProfile } from "../components/paragraphs/ParagraphNodeCountryProfile";
import { ParagraphSlideShowContentBlock } from "../components/paragraphs/ParagraphSlideShowContentBlock";
import { ParagraphTextWithBackgroundImage } from "../components/paragraphs/ParagraphTextWithBackgroundImage";
import { ParagraphFlexibleColumn } from "../components/paragraphs/ParagraphFlexibleColumn";
import { ParagraphMediaBlendContentBlock } from "../components/paragraphs/ParagraphMediaBlendContentBlock";
import { ParagraphLargeSliderContentBlock } from "../components/paragraphs/ParagraphLargeSliderContentBlock";
import { ParagraphLatestFeaturedContentBlock } from "../components/paragraphs/ParagraphLatestFeaturedContentBlock";
import { ParagraphNodePublication } from "../components/paragraphs/ParagraphNodePublication";
import { ParagraphNodeGoodPractice } from "../components/paragraphs/ParagraphNodeGoodPractice";
import { ParagraphNodePartnerSpotlight } from "../components/paragraphs/ParagraphNodePartnerSpotlight";
import { ParagraphMediaBeside } from "../components/paragraphs/ParagraphMediaBeside";
import { ParagraphNodeShorthand } from "../components/paragraphs/ParagraphNodeShorthand";
import { ParagraphNodeEvents } from "../components/paragraphs/ParagraphNodeEvents";
import { ParagraphCarouselSlider } from "../components/paragraphs/ParagraphCarouselSlider";
import { ParagraphGenericAccordion } from "../components/paragraphs/ParagraphGenericAccordion";
import { ParagraphTabComponent } from "../components/paragraphs/ParagraphTabComponent";
import { ParagraphResponsiveTabs } from "../components/paragraphs/ParagraphResponsiveTabs";
import { ParagraphCountryMap } from "../components/paragraphs/ParagraphCountryMap";
import { ParagraphNodeFeaturesIframe } from "../components/paragraphs/ParagraphNodeFeaturesIframe";
import { ParagraphListingPageTemplate } from "../components/paragraphs/ParagraphListingPageTemplate";
import { ParagraphParallaxImageBanner } from "../components/paragraphs/ParagraphParallaxImageBanner";
import { ParagraphNavLinks } from "../components/paragraphs/ParagraphGridNavbar";
import { ParagraphVideoPromo } from "../components/paragraphs/ParagraphVideoPromo";
import { ParagraphRichTextContentBlock } from "../components/paragraphs/ParagraphRichTextContentBlock";
import { ParagraphRegionalOverview } from "../components/paragraphs/ParagraphRegionalOverview";
import { ParagraphDownloads } from "../components/paragraphs/ParagraphDownloads";
import { ParagraphMapContentBlock } from "../components/paragraphs/ParagraphMapContentBlock";
import { ParagraphInfographicHeaderLP } from "../components/paragraphs/ParagraphInfographicHeaderLP";
import { ParagraphColumnEqual } from "../components/paragraphs/ParagraphColumnEqual";
import { ParagraphFlagshipSlider } from "../components/paragraphs/ParagraphFlagshipSlider";

const components = {
  paragraph__paragraph_text_block: ParagraphParagraphTextBlock,
  paragraph__paragraph_header_image: ParagraphHeaderImage,
  paragraph__links: ParagraphLinks,
  paragraph__quote1: ParagraphQuoteBlock,
  paragraph__simple_quote: ParagraphSimpleQuote,
  paragraph__department_block_people: ParagraphDepartmentBlockPeople,
  paragraph__with_thanks: ParagraphPartnerLogos,
  paragraph__key_publications: ParagraphKeyPublications,
  node__expert_opinion: ParagraphNodeExpertOpinion,
  node__media_centre: ParagraphNodeMediaCentre,
  node__partner_spotlight: ParagraphNodePartnerSpotlight,
  paragraph__slideshow: ParagraphSlideShowContentBlock,
  paragraph__text_with_background_image: ParagraphTextWithBackgroundImage,
  paragraph__flexible_column: ParagraphFlexibleColumn,
  paragraph__media_blend_content_block: ParagraphMediaBlendContentBlock,
  paragraph__large_slider_content_block: ParagraphLargeSliderContentBlock,
  paragraph__latest_report_content_block: ParagraphLatestFeaturedContentBlock,
  node__publications: ParagraphNodePublication,
  node__country_profile: ParagraphNodeCountryProfile,
  paragraph__media_beside_content_block: ParagraphMediaBeside,
  node__shorthand: ParagraphNodeShorthand,
  node__events: ParagraphNodeEvents,
  node__good_practice: ParagraphNodeGoodPractice,
  node__iframe: ParagraphNodeFeaturesIframe,
  paragraph__carousel_slider: ParagraphCarouselSlider,
  paragraph__generic_accordion: ParagraphGenericAccordion,
  paragraph__tab_component: ParagraphTabComponent,
  paragraph__responsive_tab: ParagraphResponsiveTabs,
  paragraph__countries_map_paragraph: ParagraphCountryMap,
  paragraph__listing_page_template: ParagraphListingPageTemplate,
  paragraph__navigation_links: ParagraphNavLinks,
  paragraph__parallax_image_banner: ParagraphParallaxImageBanner,
  paragraph__video_promo: ParagraphVideoPromo,
  paragraph__rich_text: ParagraphRichTextContentBlock,
  paragraph__regional_overview: ParagraphRegionalOverview,
  paragraph__downloads_cta_lp: ParagraphDownloads,
  paragraph__map_content_block: ParagraphMapContentBlock,
  paragraph__infographic_header_lp: ParagraphInfographicHeaderLP,
  paragraph__column_equal: ParagraphColumnEqual,
  paragraph__flagship_slider: ParagraphFlagshipSlider,
};

export const getParagraph = (node, extras) => {
  if (components.hasOwnProperty(node.type || node.publicationType)) {
    const ParagraphComponent = components[node.type || node.publicationType];
    return <ParagraphComponent key={node.id} node={node} {...extras} /> || <></>;
  }
  return;
};
